import { render, staticRenderFns } from "./ConfiguracionComandosSMSPantalla.vue?vue&type=template&id=657b1bfb&scoped=true&"
import script from "./ConfiguracionComandosSMSPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionComandosSMSPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657b1bfb",
  null
  
)

export default component.exports